module.exports = __webpack_public_path__ + "img/A3B2A4_3B3E3D_676F6A_535C57-256px.41bb864f.png";